import { cn } from "cn"

export function UserStatusDot({
  active,
  bot,
  className,
}: {
  active: boolean
  bot?: boolean
  className?: string
}) {
  return (
    <span
      className={cn(
        "aspect-square rounded-full",
        active && (bot ? "bg-blue-8" : "bg-green-8"),
        !active && "border border-gray-8 bg-background",
        className
      )}
    />
  )
}
